<template>
	<div class="hallMain" v-if="from!=='baidu'">
		<div class="iconfont" @click="gobacklast">&#xe618;</div>
		<div class="otitle">{{list.obj.lotteryName}}历史开奖</div>
		<div 
			class="zhuduijiang" 
			v-if="list.obj.lotteryId=='001'||list.obj.lotteryId=='113'||list.obj.lotteryId=='002'||list.obj.lotteryId=='108'"
			@click="appjumpzst(list.obj.lotteryId)"
		>走势图</div>
	</div>
	<div class="hallList">
		<template v-if="list.obj.lotteryId=='001'||list.obj.lotteryId=='113'||list.obj.lotteryId=='002'||list.obj.lotteryId=='108'||list.obj.lotteryId=='110'||list.obj.lotteryId=='109'||list.obj.lotteryId=='003'">
			<div class="ssq-dlt" @click="gotodetail(list.obj.lotteryId,sitem.issue,from)" v-for="(sitem,index) in newList" :key="index">
			<div class="modeltop">
				<span class="issues">{{sitem.issue}}期</span>
				<span class="dates">{{sitem.ernieDateStr}}</span>
			</div>
			<div class="fcbot" :class="index==0?'nowissue':''">
				<ul class="kjgg">
					<li class="kjred" v-for="bal in sitem.redball" :key="bal">{{bal}}</li>
					<li class="kjbule" v-for="balue in sitem.blueball" :key="balue">{{balue}}</li>
				</ul>
				<div class="iconfont right">&#xe615;</div>
			</div>
		</div>
		</template>
		<template v-if="list.obj.lotteryId=='300'||list.obj.lotteryId=='302'||list.obj.lotteryId=='303'">
			<div class="ssq-dlt" @click="gotodetail(list.obj.lotteryId,sitem.issue,from)" v-for="(sitem,index) in newList" :key="index">
			<div class="modeltop">
				<span class="issues">{{sitem.issue}}期</span>
				<span class="dates">{{sitem.ernieDateStr}}</span>
			</div>
			<div class="fcbot" :class="index==0?'nowissue':''">
				<ul class="kjgg-fangk">
					<li class="kjred" v-for="bal in sitem.redball" :key="bal">{{bal}}</li>
				</ul>
				<div class="iconfont right">&#xe615;</div>
			</div>
		</div>
		</template>
		<div class="ts">
			*当前仅展示近20期开奖数据
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { useRoute,useRouter } from 'vue-router'
	import { ref,reactive,getCurrentInstance,onMounted } from 'vue'
	export default{
		name:'History',
		setup(){
			const { params:{lotid}} = useRoute()
			const baseurl = getCurrentInstance().appContext.config.globalProperties.axiosurl
			const router = useRouter()
			let from = ''
			const route = useRoute()
			if(route.query.from&&route.query.from==='baidu'){
				from = 'baidu'
			}
			console.log(from)
			let list = reactive({
				obj: {}
			})
			let newList = ref([])
			const getHisList = async()=>{
				const { data:hisdata } = await axios.post(`${baseurl}/hdTransfer/methodNormal?function=synLotteryList&lotteryId=${lotid}&pageNo=1&&pageSize=20`)
				list.obj.lotteryName = hisdata.lotteryName
				list.obj.lotteryId = hisdata.lotteryId
				console.log(list.obj.lotteryId)
				newList.value = hisdata.relist.map((value,index)=>{
					let obj = {
						issue:value.issue,
						ernieDateStr:value.ernie_datestr,
						redball:[],
						blueball:[]
					}
					if(lotid=="303"||lotid=="302"||lotid=="300"){
						obj.redball = value.lotteryNumber.split(",")
					}else{
						obj.redball = value.lotteryNumber.split('+')[0].split(',')
						obj.blueball = value.lotteryNumber.split('+')[1]?value.lotteryNumber.split('+')[1].split(','):[]
					}
					return obj
				})
				console.log(newList.value)
			}
			const appjumpzst = (lotid)=>{
				window.location.href = `http://trendchart?${lotid}`
			}
			const gobacklast = ()=>{
				router.back()
			}
			const gotodetail =(lot,issues,from)=>{
				if(from==='baidu'){
					router.push({name:'Detail',params:{lotid:lot,issue:issues},query:{from:from}})
				}else{
					router.push({name:'Detail',params:{lotid:lot,issue:issues}})
				}
				
			}
			getHisList()
			
			onMounted(()=>{
				if(route.fullPath.indexOf('sid')>-1){
					const arrayurl = route.fullPath.split('?')
					let sidvalue = ''
					arrayurl.forEach((v,i)=>{
						if(v.indexOf('sid')>-1){
							sidvalue = v.split('=')[1]
							localStorage.newsid = sidvalue
						}
					})
				}
			})
			return { list,appjumpzst,newList,gobacklast,gotodetail,from }
		}
	}
</script>

<style scoped="scoped">
	.hallMain{position:relative;width:3.75rem;height:.44rem;color:#42B983;background-color: #FFFFFF;padding:0 .15rem 0 .1rem;box-sizing: border-box;}
	.hallMain .iconfont{width:.2rem;height:.2rem;color:#333333;font-size: .18rem;position: absolute;left:.15rem;top:.12rem;}
	.otitle{width:100%;height:100%;text-align: center;font-size:.18rem;color:#333333;font-weight: bold;line-height: .44rem;}
	.zhuduijiang{font-size:.15rem;color:#333333;position: absolute;right:.15rem;top:.12rem;}
	
	.hallList{width:100%;background:#F4F4F4;padding:0 .1rem .1rem .1rem;box-sizing: border-box;display:flex;flex-direction: column;align-items: center;}
	.hallList .ssq-dlt{
	    width: 3.55rem;
	    height: 1rem;
	    margin-top: .1rem;
	    display: flex;
	    flex-direction: column;
	    background: #FFFFFF;
	    border-radius: .04rem;
	    padding: .15rem;
	    box-sizing: border-box;
	}
	.modeltop{
	    width: 100%;
	    display: flex;
	    flex-direction: row;
	    align-items: center;
	}
	.fcbot{
	    width: 100%;
	    height: .6rem;
	    display: flex;
	    flex-direction: row;
	    justify-content: space-between;
	    align-items: center;
	}
	.issues{
	    font-size: .12rem;
	    color: #333333;
	    margin-right: .05rem;
	}
	.dates{
	    font-size: .12rem;
	    color: #999999;
	}
	.fcbot .kjgg{
	    width: 3rem;
	    height: 100%;
	    display: flex;
	    flex-direction: row;
	    align-items: center;
	}
	.right{
	    width: .13rem;
	    height: .2rem;
	    font-size: .2rem;
	}
	.fcbot.nowissue .kjgg li{
	    text-align: center;
	    line-height: .3rem;
	    width: .3rem;
	    margin-right: .06rem;
	    height: .3rem;
	    font-size: .14rem;
	    border-radius: 50%;
	    -webkit-border-radius: 50%;
	    -moz-border-radius: 50%;
	    -ms-border-radius: 50%;
	    -o-border-radius: 50%;
	}
	.fcbot.nowissue .kjgg li.kjbule{
	    background: #2E9FFE;
	    color: #fff;
	}
	.fcbot.nowissue .kjgg li.kjred{
	    background: #F44444;
	    color: #fff;
	}
	.fcbot.nowissue .kjgg-fangk{
	    width: 2.85rem;
	    height: 100%;
	    display: flex;
	    flex-direction: row;
	    align-items: center;
	}
	.fcbot.nowissue .kjgg-fangk li{
	    background: #F44444;
	    color: #fff;
	    text-align: center;
	    line-height: .32rem;
	    width: .2rem;
	    margin-right: .06rem;
	    height: .32rem;
	    font-size: .14rem;
	    border-radius: .01rem;
	    -webkit-border-radius: .01rem;
	    -moz-border-radius: .01rem;
	    -ms-border-radius: .01rem;
	    -o-border-radius: .01rem;
	}
	
	.fcbot .kjgg li{
	    text-align: center;
	    line-height: .3rem;
	    width: .3rem;
	    margin-right: .06rem;
	    height: .3rem;
	    font-size: .14rem;
	}
	.fcbot .kjgg li.kjbule{
	    color: #2E9FFE;
	}
	.fcbot .kjgg li.kjred{
	    color: #F44444;
	}
	.fcbot .kjgg-fangk{
	    width: 2.85rem;
	    height: 100%;
	    display: flex;
	    flex-direction: row;
	    align-items: center;
	}
	.fcbot .kjgg-fangk li{
	    color: #F44444;
	    text-align: center;
	    line-height: .32rem;
	    width: .2rem;
	    margin-right: .06rem;
	    height: .32rem;
	    font-size: .14rem;
	}
	.ts{
		margin-top: .12rem;
		color:#999999;
		font-size: .12rem;
		text-align: center;
		line-height: .26rem;
	}
</style>
